/**
 * Converte o nome digitado na criação de um tipo de contrato para o padrão aceito pelo
 * contract (`A-Z`, `0-9`, `_`): maiúsculas, sem acento, espaços viram `_` (AF-4197).
 */
export const normalizeContractTypeName = (raw: string): string => {
    return raw.normalize('NFD').replace(/\p{Diacritic}/gu, '').trim().toUpperCase().replace(/\s+/g, '_');
};
